import { render } from "./VideoTrigger.vue?vue&type=template&id=ef0e05b6"
import script from "./VideoTrigger.vue?vue&type=script&lang=js"
export * from "./VideoTrigger.vue?vue&type=script&lang=js"

import "./VideoTrigger.vue?vue&type=style&index=0&id=ef0e05b6&lang=scss"
script.render = render

export default script